import i18n from './../../shared/i18n';
import BaseModel, {defineTranslatableProperties} from "../../core/components/input-widget/BaseModel";

export default class LiveLotsPerformanceSearch extends BaseModel {
  savedSaleUUID = null;

  rules = {};

  attributeLabels = {
    savedSaleUUID: i18n.t('savedSaleUUID'),
  };

  attributePlaceholders = this.attributeLabels;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}

defineTranslatableProperties(LiveLotsPerformanceSearch);
